module.exports = __webpack_public_path__ + "assets/3ed70f8d18713dc7c71a1ec9b7688cc1.svg";